var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WorkspaceSettingsPage',[_c('div',{staticClass:"card"},[_c('CardHeading',{attrs:{"title":_vm.$t('settings.threat_management.heading').toString(),"text":_vm.$t('settings.threat_management.text').toString()}}),_c('div',{staticClass:"p-4"},[_c('ThreatManagementSettingsForm',{on:{"saved":_vm.handleSaved}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }